import { environment } from './environment';

function hostFromUrl(url: string): string {
  try {
    return new URL(url).hostname.toLowerCase();
  } catch {
    return url
      .replace(/^https?:\/\//i, '')
      .split('/')[0]
      .split(':')[0]
      .toLowerCase();
  }
}

/** Resolved once at startup before initEnvironmentFromHost() can mutate environment.baseHref. */
const PRIMARY_HOST = environment.baseHref ? hostFromUrl(environment.baseHref) : '';
const SECONDARY_HOST = environment.baseHref2 ? hostFromUrl(environment.baseHref2) : '';

export const ESS_DASHBOARD_ROUTE = '/master/ess/dashboard';

export function getEssDashboardRoute(): string[] {
  return ['/master', 'ess', 'dashboard'];
}

function isOnBaseHref2Host(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }

  const currentHost = window.location.hostname.toLowerCase();
  const currentOrigin = window.location.origin.toLowerCase();
  const secondaryOrigin = environment.baseHref2
    ? environment.baseHref2.replace(/\/$/, '').toLowerCase()
    : '';

  if (SECONDARY_HOST && currentHost === SECONDARY_HOST) {
    return true;
  }

  if (secondaryOrigin && currentOrigin === secondaryOrigin) {
    return true;
  }

  // Same build serves multiple BYV domains (e.g. bgesbyv.bookyourvoyage.com).
  if (currentHost.includes('bookyourvoyage') && currentHost !== PRIMARY_HOST) {
    return true;
  }

  return false;
}

export function isOnPrimaryHost(hostname?: string): boolean {
  if (typeof window === 'undefined' && !hostname) {
    return false;
  }

  const host = (hostname ?? window.location.hostname).toLowerCase();
  return !!PRIMARY_HOST && host === PRIMARY_HOST;
}

export function shouldUseByvDashboard(): boolean {
  return isOnBaseHref2Host();
}

export function isBaseHref2Host(): boolean {
  return isOnBaseHref2Host();
}

export function isBookYourVoyageHost(hostname?: string): boolean {
  if (typeof window === 'undefined' && !hostname) {
    return false;
  }

  const host = (hostname ?? window.location.hostname).toLowerCase();

  if (SECONDARY_HOST && host === SECONDARY_HOST) {
    return true;
  }

  return host.includes('bookyourvoyage') && host !== PRIMARY_HOST;
}

export function initEnvironmentFromHost(): void {
  if (typeof window === 'undefined') {
    return;
  }
  if (isOnBaseHref2Host()) {
    environment.baseHref = environment.baseHref2 || `${window.location.origin}/`;
  }
}

export function getBrandLogoAssetPath(): string {
  return isBookYourVoyageHost()
    ? 'assets/BYV_logo.png'
    : 'assets/BBG-logo.svg';
}

export function getLoginBrandLogoAssetPath(): string {
  return isBookYourVoyageHost()
    ? 'assets/BYV_logo.png'
    : 'assets/icons/cropped-LogoBranco.png';
}

export function getLoginWelcomeMessage(): string {
  return isBookYourVoyageHost()
    ? 'Welcome to Book Your Voyage'
    : 'Welcome to Blueberry Group';
}
